import { FormikProps } from "formik";
import { FirmaDto } from "../../../../../../interfaces/schema";
import { DisplayItem } from "../../../../../formcontrols/DisplayItem";
import { TextInputFormik } from "../../../../../formcontrols/InputItem";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "../../../../../select/Select";
import { FirmaFields } from "./StamoplysningerTop";

const FirmaStamFakturering = ({
  firma,
  editMode,
  formik,
}: {
  firma: FirmaDto;
  editMode: boolean;
  formik: FormikProps<FirmaFields>;
}) => {
  const { values } = formik;
  const { fakturaAfsendelse } = values;
  return (
    <div className="c-card c-item-list">
      <h4 className="flex-100">Fakturering</h4>
      {editMode && (
        <>
          <div>
            <label className="form-label">Faktura afsend standard</label>
            <Select
              defaultValue={firma.fakturaAfsendelse}
              value={fakturaAfsendelse}
              onValueChange={(e) =>
                formik.setFieldValue("fakturaAfsendelse", e)
              }
            >
              <SelectTrigger
                aria-label="Afsend standard"
                placeholder="Vælg..."
              />
              <SelectContent>
                <SelectItem value="EAN">EAN</SelectItem>
                <SelectItem value="EBOKS">E-Boks</SelectItem>
                <SelectItem value="EMAIL">Email</SelectItem>
                <SelectItem value="BREV">Brev</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </>
      )}
      {!editMode && (
        <div>
          <DisplayItem
            label="Faktura afsend standard"
            text={firma.fakturaAfsendNavigation?.navn}
            isEditable
          />
        </div>
      )}
      <div>
        {!editMode && (
          <DisplayItem
            label="E-mail, faktura"
            text={firma.fakturaEmail}
            isEditable
          />
        )}
        {editMode && (
          <TextInputFormik
            config={{
              component: "textinput",
              id: "fakturaEmail",
              initialValue: values.fakturaEmail ?? "",
              label: "E-mail, faktura",
            }}
            formik={formik}
          />
        )}
      </div>
      <div>
        {!editMode && (
          <DisplayItem label="EAN-nr." text={firma.ean} isEditable />
        )}
        {editMode && (
          <TextInputFormik
            config={{
              component: "textinput",
              id: "ean",
              initialValue: values.ean ?? "",
              label: "EAN-nr.",
            }}
            formik={formik}
          />
        )}
      </div>
      <div>
        {!editMode && (
          <DisplayItem
            label="Reference"
            text={firma.fakturaReference}
            isEditable
          />
        )}
        {editMode && (
          <TextInputFormik
            config={{
              component: "textinput",
              id: "fakturaReference",
              initialValue: values.fakturaReference ?? "",
              label: "Reference",
            }}
            formik={formik}
          />
        )}
      </div>
    </div>
  );
};

export default FirmaStamFakturering;
